/* global I18n */
I18n.defaultLocale = 'fr';
I18n.availableLocales = ['fr', 'nl'];
I18n.locale = window.document.documentElement.lang || I18n.defaultLocale;


if (process.env.NODE_ENV === 'test') {
  I18n.missingTranslation = (scope) => {
    console.error(`I18n key missing: ${scope}`)
  }
}
